module.exports = __webpack_public_path__ + "img/9.1aa67bb2.jpg";